<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue">Government Web Technologies</span>
  </h4>

  <table style="margin-left: 10px; margin-right: 10px">
    <caption>
      The Three Most Popular JavaScript Libraries
    </caption>
    <thead>
      <tr>
        <th>Library</th>
        <th>jQuery</th>
        <th>Bootstrap</th>
        <th>Modernizr</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Market Share</td>
        <td>96.1%</td>
        <td>17.0%</td>
        <td>14.3%</td>
      </tr>
      <tr>
        <td>Absolute Usage</td>
        <td>70.4%</td>
        <td>12.4%</td>
        <td>10.5%</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="4">
          <em>Market Share</em> refers to the percentage of sites using any
          JavaScript library that use the specified library.
          <em>Absolute Usage</em> is the percent of websites surveyed, including
          those that use no JavaScript libraries, that use the specified
          library. All data comes from
          <a
            href="https://w3techs.com/technologies/overview/javascript_library/all"
            target="_blank"
            >W3Techs</a
          >
          and was accurate in June of 2016.
        </td>
      </tr>
    </tfoot>
  </table>

  Read more: https://html.com/tags/table/#ixzz7hcya3BQT
</template>

<script>
export default {};
</script>

<style scoped>
table {
  border: 2px solid #774f38;
  border-collapse: collapse;
  display: inline-table;
}
td {
  border: 1px solid #fa6900;
  padding: 5px 10px;
}
thead {
  background-color: #f1d4af;
}
tfoot {
  background-color: #c5e0dc;
}
.divLeft {
  text-align: left;
}
.divRight {
  text-align: right;
}
</style>
